"use strict";
exports.__esModule = true;
var Organization = /** @class */ (function () {
    function Organization(_a) {
        var createdAt = _a.createdAt, id = _a.id, name = _a.name;
        var _this = this;
        this.toJSON = function () { return ({
            createdAt: _this.createdAt,
            id: _this.id,
            name: _this.name
        }); };
        this.createdAt = createdAt;
        this.id = id;
        this.name = name;
    }
    Organization.fromJSON = function (json) {
        var _a = Object.assign({}, json), createdAt = _a.createdAt, id = _a.id, name = _a.name;
        if (typeof createdAt !== 'string')
            throw new Error('.createdAt must be a string');
        if (typeof id !== 'string' && id !== undefined && id !== null)
            throw new Error('.id must be a string');
        if (typeof name !== 'string' && name !== undefined && name !== null)
            throw new Error('.name must be an array');
        return new Organization({
            createdAt: createdAt,
            id: id,
            name: name
        });
    };
    return Organization;
}());
exports["default"] = Organization;
